module.exports = __webpack_public_path__ + "img/activity_bcg.9f5c32e2.png";